import { ssApiService } from '../../../services/ss-api.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { EmailDialog } from '../../../dialogs/email/email.dialog';
import { EmailPreviewDialog } from '../../../dialogs/email.preview/email.preview.dialog';
import { MemberDashboard } from '../../../models/ss-api/responses/member.dashboard.response';
import { EmailLogItemBasicArray, EmailLogItemBasic } from '../../../models/domain/email.log.item.basics';
import { EmailWindowType } from '../../../../app/models/domain/email.window.request';
import { TemplateTypes } from '../../../../app/models/domain/email.template.item';
import { SortBot } from '../../../../app/helpers/sort';

@Component({
    selector: 'member-email',
    templateUrl: './member.email.component.html',
    styleUrls: ['./member.email.component.css']
})
export class MemberEmailComponent implements OnInit, OnDestroy {

    @Input('IsBusy') IsBusy: boolean;
    @Input('MemberID') MemberID: number;
    @Input('MemberData') MemberData: MemberDashboard;
    @Input('EmailLogs') EmailLogs: EmailLogItemBasicArray;

    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    EmailSearch: String;

    emailResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private dialogService: DialogService, private api: ssApiService) { }

    SortByDate() { this.EmailLogs = SortBot.SortAuto<EmailLogItemBasicArray>(this.EmailLogs, 'DateTime'); }

    ngOnInit() {
        this.IsBusy = false;
    }

    ngOnDestroy() {
    }

    showEmailDialog() {
        let disposable = this.dialogService.addDialog(EmailDialog, {
            Type: EmailWindowType.Member,
            MemberData: this.MemberData,
            Templates: [TemplateTypes.CustomerService, TemplateTypes.System, TemplateTypes.TechSupport]
        }, { width: 1100, height: 800 }).subscribe(response => {
            this.ReloadEmails();
            disposable.unsubscribe();
        });
    }

    showEmailPreview(emailItem: EmailLogItemBasic) {
        let disposable = this.api.GetEmailLog(emailItem.ID).subscribe(response => {
            disposable.unsubscribe();
            let tempDialog = this.dialogService.addDialog(EmailPreviewDialog, {
                MemberID: response.Data.MemberID,
                emailID: response.Data.ID,
                emailContent: response.Data.Body,
                emailSubject: response.Data.Subject
            }, { height: 800 }).subscribe(result => { });
        });
    }

    ReloadEmails() {
        this.onRefresh.emit('yougotmail');
    }

    paginateEmails(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
